/**
 * Retrieves the translation of text.
 *
 * @see https://developer.wordpress.org/block-editor/packages/packages-i18n/
 */
import { __ } from '@wordpress/i18n';

export const writingStyles = [
    {
        title: __('Informative', 'momoacg'),
        value: 'Informative',
    },
    {
        title: __('Descriptive', 'momoacg'),
        value: 'Descriptive',
    },
    {
        title: __('Creative', 'momoacg'),
        value: 'Creative',
    },
    {
        title: __('Analytical', 'momoacg'),
        value: 'Analytical',
    },
    {
        title: __('Journalistic', 'momoacg'),
        value: 'Journalistic',
    },
    {
        title: __('Narrative', 'momoacg'),
        value: 'Narrative',
    },
    {
        title: __('Humorous', 'momoacg'),
        value: 'Humorous',
    },
    {
        title: __('Formal', 'momoacg'),
        value: 'Formal',
    },
    {
        title: __('Informal', 'momoacg'),
        value: 'Informal',
    },
];

export const languages = [
    {
        title: __('English', 'momoacg'),
        value: 'English',
    },
    {
        title: __('Spanish', 'momoacg'),
        value: 'Spanish',
    },
    {
        title: __('Dutch', 'momoacg'),
        value: 'Dutch',
    },
    {
        title: __('French', 'momoacg'),
        value: 'French',
    },
    {
        title: __('German', 'momoacg'),
        value: 'German',
    },
    {
        title: __('Portugese', 'momoacg'),
        value: 'Portugese',
    },
    {
        title: __('Russian', 'momoacg'),
        value: 'Russian',
    },
    {
        title: __('Chinese', 'momoacg'),
        value: 'Chinese',
    },
    {
        title: __('Japanese', 'momoacg'),
        value: 'Japanese',
    },
    {
        title: __('Arabic', 'momoacg'),
        value: 'Arabic',
    },
    {
        title: __('Hindi', 'momoacg'),
        value: 'Hindi',
    },
    {
        title: __('Indonesian', 'momoacg'),
        value: 'Indonesian',
    },
    {
        title: __('Italian', 'momoacg'),
        value: 'Italian',
    },
];